import { render, staticRenderFns } from "./PartsXY.vue?vue&type=template&id=b62de054&scoped=true"
import script from "./PartsXY.vue?vue&type=script&lang=js"
export * from "./PartsXY.vue?vue&type=script&lang=js"
import style0 from "./PartsXY.vue?vue&type=style&index=0&id=b62de054&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b62de054",
  null
  
)

export default component.exports